import { EstadoLlamadaComponent } from '@/erp/operaciones/instalaciones/shared/components';
import { EncuestaPreagendaCell } from '@/erp/operaciones/preagendamiento/shared/components';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import {
  ESTADO_PAGO_CHOICE,
  EstadosPreagendamientoEnumChoice,
  TIPO_PLANES_CHOICE,
  cellLineaRazonSocial,
  cellNotFilter,
  emptyCell,
  emptyCellObject,
  emptyCellOneLevel,
  fnTipoContrato,
  formatCurrency,
  formatDateWithTimeAMPM,
  formatDateWithTimeCell,
} from '..';
import { EstadoComponente, SingleIconButton } from '../components/ui';
import { Agendamiento, EstadoPagoEnum, OrdenTrabajo, IPreagendamiento } from '../interfaces';
import InfoUser from '../components/ui/InfoUser/InfoUser';
import { ShowContractsAgendaModal } from '@/erp/operaciones/agendamiento/shared/components/forms';
import ModalFotoContratoComponente from '@/erp/clientes/contrato/shared/modal-fotos-contrato-componentente/ModalFotosContratoComponente';
import InfoFormaPago from '@/erp/sale/asesor/pre_agendamiento/shared/componente/InfoFormaPago/InfoFormaPago';
import { Button } from '@mui/material';
import { openGenericObjectModal } from '../components/ui/ModalGenericObject/useGenericObjectModalStore';
import { fieldPlan } from '../utils/fields-modal-generic-object';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
interface AgendaTablaComponenteProps {
  estado_preagendamiento?: EstadosPreagendamientoEnumChoice;
}

// const { VITE_API_URL_OFICINA_VIRTUAL } = getEnvs();


export const useTableColumnsPreagendamientoVentas =
  ({ }: AgendaTablaComponenteProps) => {


    const columnaPreagendamiento = useMemo<MRT_ColumnDef<IPreagendamiento>[]>(
      () => [
        {
          accessorKey: 'cliente_razon_social',
          header: 'Nombre',
          size: 300,
          Cell: ({ row }) => (
            cellLineaRazonSocial(row.original.contrato_data, row.original.prospecto_data.razon_social)
          ),
        },
        {
          accessorKey: 'identificacion',
          header: 'identificacion',
          size: 180,
          Cell: ({ row }) =>
            row.original?.prospecto_data?.identificacion || 'N/A',
        },

        /* {
          ...cellNotFilter,
          accessorKey: 'contrato_data_documentos',
          header: 'Documentos',
          Cell: ({ row }) => (
            <ShowContractsAgendaModal
              razonSocial={cellLineaRazonSocial(row.original.contrato_data, row.original.prospecto_data.razon_social)}
              contrato={row.original.contrato_data!}
              tooltipMessage={"Documentos generados"}
              idPreventa={row.original.preventa_data.id_preventa}
              showBtnGenDocs={false}
              showBtnCopy={true}
              showBtnGenAutorizacion={
                (row.original.forma_pago_data.forma_pago != TipoFormaPagoEnumChoice.RECAUDACION && (
                  !row.original.preventa_data.url_autorizacion_debito_automatico && !row.original.preventa_data.url_autorizacion_cargo_tarjeta
                )) ? true : false
              }
              contratoFisico={row.original.preventa_data.pre_requiere_contrato_fisico || row.original.preventa_data.requiere_contrato_fisico}

              formaPago={row.original.forma_pago_data.forma_pago!}
              url_autorizacion_cargo_tarjeta={row.original.preventa_data.url_autorizacion_cargo_tarjeta}
              url_autorizacion_debito_automatico={row.original.preventa_data.url_autorizacion_debito_automatico}
            />
          )
        }, */
        {
          // ...cellNotFilter,
          accessorKey: 'requiere_contrato_fisico',
          header: 'Tipo de Contrato',
          size: 250,
          filterVariant: 'select',
          filterSelectOptions: [{ label: 'CONTRATO DIGITAL', value: 'false' }, { label: 'CONTRATO FÍSICO', value: 'true' }],
          Cell: ({ row }) => {

            const info = fnTipoContrato(
              row.original.preventa_data.pre_requiere_contrato_fisico, row.original.preventa_data.requiere_contrato_fisico);
            return <EstadoComponente
              backgroundColor={info.color}
              texto={info.texto} />
          },
        },
        /* {
          accessorKey: 'estado_aceptacion',
          header: 'Estado Aceptacion',
          filterVariant: 'select',
          filterSelectOptions: [{ label: 'FIRMADO', value: 'true' }, { label: 'PENDIENTE FIRMAR', value: 'false' }],
          size: 200,
          Cell: ({ row }) => (
            <EstadoComponente backgroundColor={row.original.preventa_data.estado_aceptacion ? 'green' : 'orange'} texto={row.original.preventa_data.estado_aceptacion ? 'FIRMADO' : 'PENDIENTE FIRMAR'} />
          )
        }, */
        {
          accessorKey: 'numero_referencia',
          header: 'Núm. Contrato',
          Cell: ({ row }) =>
            row.original?.contrato_data?.numero_referencia || 'N/A',
        },
        {
          accessorKey: 'fecha_aceptacion',
          header: 'fecha aceptacion',
          size: 200,
          Cell: ({ row }) => (
            row.original.preventa_data.fecha_aceptacion != null ?
              formatDateWithTimeAMPM(row.original.preventa_data.fecha_aceptacion) : 'N/A'
          )
        },
        {
          ...cellNotFilter,
          accessorKey: 'Observación PYL',
          header: 'Observación PYL',
          size: 250,
          Cell: ({ row }) => (
            row.original.observaciones != null
              ? row.original.observaciones.observacion_llamada != null
                ? row.original.observaciones.observacion_llamada
                : 'N/A'
              : 'N/A'
          )
        },
        {
          ...cellNotFilter,
          accessorKey: 'estado_preagendamiento',
          header: 'Estado Preagendamiento',
          Cell: ({ row }) => (
            <EstadoComponente
              backgroundColor={row.original.estado_preagendamiento === EstadosPreagendamientoEnumChoice.APROBADO ? 'green' : 'red'}
              texto={row.original?.estado_preagendamiento || 'N/A'}
            />
          ),
        },
        {
          accessorKey: 'motivo_rechazo',
          header: 'Motivo Rechazo',
          size: 200,
          Cell: ({ row }) => (
            emptyCellObject(row.original.motivo_rechazo_data, 'nombre')
          )
        },
        {
          accessorKey: 'observacion_cancelacion',
          header: 'Observación Cancelación',
          size: 200,
          Cell: ({ row }) => (
            emptyCell(row.original.observaciones?.observacion_cancelacion)
          )
        },

        ////* estado_pago ------------------
        {
          filterVariant: 'select',
          filterSelectOptions: ESTADO_PAGO_CHOICE,
          accessorKey: 'estado_pago',
          header: 'estado pago',
          enableColumnFilter: false,
          enableSorting: false,
          Cell: ({ row }) => {
            const isPendingVoucher =
              row.original?.estado_pago === EstadoPagoEnum.VOUCHER_PENDIENTE;
            return (
              <EstadoComponente
                backgroundColor={isPendingVoucher ? 'orange' : 'green'}
                texto={row.original?.estado_pago || 'N/A'}
              />
            );
          },
        },
        {
          ...cellNotFilter,
          accessorKey: 'descripcion_pago',
          header: 'Descripción de pago',
          size: 300,
          enableColumnFilter: false,
          enableSorting: false,
          Cell: ({ row }) => emptyCellOneLevel(row, 'descripcion_pago'),
        },


        // -------------
        {
          ...cellNotFilter,
          accessorKey: 'direccion',
          header: 'direccion',
          size: 300,
          Cell: ({ row }) => row.original?.preventa_data?.direccion || 'N/A',
        },
        {
          ...cellNotFilter,
          accessorKey: 'fecha_hora_instalacion',
          header: 'FECHA Y HORA INSTALACION',
          size: 210,
          enableColumnFilter: true,
          enableSorting: true,
          Cell: ({ row }) =>
            `${row.original.fecha_instalacion} ${row.original.hora_instalacion}`,
        },
        {
          accessorKey: 'coordenadas',
          header: 'COORDENADAS',
          size: 210,
          Cell: ({ row }) => emptyCellOneLevel(row, 'coordenadas'),
        },
        {
          ...cellNotFilter,
          accessorKey: 'celular',
          header: 'CELULAR CLIENTE',
          size: 180,
          Cell: ({ row }) => row.original?.prospecto_data?.celular || 'N/A',
        },
        {
          ...cellNotFilter,
          accessorKey: 'celular_2',
          header: 'CELULAR 2',
          size: 180,
          Cell: ({ row }) => row.original?.preventa_data?.celular_2 || 'N/A',
        },
        {
          ...cellNotFilter,
          accessorKey: 'email',
          header: 'EMAIL',
          size: 180,
          Cell: ({ row }) => row.original?.preventa_data?.email || 'N/A',
        },

        // Persona de referencia ------------------
        {
          ...cellNotFilter,
          accessorKey: 'persona_referencia_nombre',
          header: 'Persona de referencia',
          size: 210,
          Cell: ({ row }) =>
            row.original?.preventa_data?.persona_referencia_nombre || 'N/A',
        },
        {
          ...cellNotFilter,
          accessorKey: 'persona_referencia_celular',
          header: 'Celular de referencia',
          size: 210,
          Cell: ({ row }) =>
            row.original?.preventa_data?.persona_referencia_celular || 'N/A',
        },
        {
          ...cellNotFilter,
          accessorKey: 'persona_referencia_celular_2',
          header: 'Celular de referencia 2',
          size: 210,
          Cell: ({ row }) =>
            row.original?.preventa_data?.persona_referencia_celular_2 || 'N/A',
        },
        {
          ...cellNotFilter,
          accessorKey: 'persona_referencia_parentesco',
          header: 'Parentesco de referencia',
          size: 210,
          Cell: ({ row }) =>
            row.original?.preventa_data?.persona_referencia_parentesco || 'N/A',
        },

        ///* fk ========================================

        // // plan ------------------
        {
          ...cellNotFilter,
          accessorKey: 'tipo_plan',
          header: 'Tipo Plan',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.tipo_plan || 'N/A';
          },
        },
        {
          ...cellNotFilter,
          accessorKey: 'tipo_servicio',
          header: 'Tipo de servicio',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.tipo_servicio || 'N/A';
          },
        },
        {
          accessorKey: 'plan',
          header: 'Plan',
          filterVariant: 'select',
          size: 200,
          filterSelectOptions: TIPO_PLANES_CHOICE,
          Cell: ({ row }) => (
            row.original.plan_data
              ? <Button
                startIcon={<OpenInNewIcon />}
                onClick={() => {
                  openGenericObjectModal({
                    data: row.original.plan_data!,
                    fields: fieldPlan,
                    title: "Plan",
                    emptyFallback: "—",
                  });
                }}
              >
                {row.original.plan_data.nombre}
              </Button>
              : '—'
          ),
        },
       
        // valor_instalacion ------------------
        {
          ...cellNotFilter,
          accessorKey: 'valor_instalacion',
          header: 'Valor Instalación',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.valor_instalacion
              ? formatCurrency(row.original?.preventa_data?.valor_instalacion)
              : formatCurrency(0);
          },
        },
        {
          ...cellNotFilter,
          accessorKey: 'valor_instalacion_iva',
          header: 'Valor IVA Instalación',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.valor_instalacion_iva
              ? formatCurrency(
                row.original?.preventa_data?.valor_instalacion_iva
              )
              : formatCurrency(0);
          },
        },
        {
          ...cellNotFilter,
          accessorKey: 'valor_instalacion_total',
          header: 'Valor Total Instalación',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.valor_instalacion_total
              ? formatCurrency(
                row.original?.preventa_data?.valor_instalacion_total
              )
              : formatCurrency(0);
          },
        },

        // flota & nap ------------------
        {
          accessorKey: 'flota',
          header: 'FLOTA',
          size: 180,
          Cell: ({ row }) => row.original?.flota_data?.nombre || 'N/A',
        },
        {
          accessorKey: 'nap_data_nombre',
          header: 'NAP',
          size: 180,
          Cell: ({ row }) => row.original?.nap_data_nombre || 'N/A',
        },
        {
          accessorKey: 'distancia',
          header: 'DISTANCIA A LA NAP',
          size: 180,
          Cell: ({ row }) => emptyCellOneLevel(row, 'distancia'),
        },

        // encuesta y usos ------------------
        {
          ...cellNotFilter,
          accessorKey: 'encuesta',
          header: 'Encuesta',
          size: 81,
          Cell: ({ row }) => {
            return (
              <EncuestaPreagendaCell encuesta={row.original.encuesta as any} />
            );
          },
        },

        // segmentacion ------------------
        {
          ...cellNotFilter,
          accessorKey: 'segmentacion',
          header: 'SEGMENTACIÓN',
          size: 180,
          Cell: ({ row }) =>
            row.original?.prospecto_data?.segmentacion || 'N/A',
        },
        {
          ...cellNotFilter,
          accessorKey: 'puntaje_score',
          header: 'PUNTAJE SCORE',
          size: 180,
          Cell: ({ row }) =>
            row.original?.prospecto_data?.puntaje_score || 'N/A',
        },

        {
          ...cellNotFilter,
          accessorKey: 'canal_venta_create',
          header: 'Canal Venta',
        },
        {
          ...cellNotFilter,
          accessorKey: 'forma_pago_data.alias',
          header: 'Forma de Pago',
          Cell: ({ row }) => (
            <InfoFormaPago
              preventa_data={row.original.preventa_data!}
              forma_pago_data={row.original.forma_pago_data}
              forma_pago_v2_data={(row.original as any).forma_pago_v2_data} />
          )
        },
        {
          accessorKey: 'user_create',
          header: 'Asesor Venta',
          size: 200,
          Cell: ({ row }) => (
            <InfoUser
              user={row.original.user_create}
            />
          )
        },
        {
          accessorKey: 'fecha_creacion',
          header: 'Fecha de Creación',
          size: 200,
          enableColumnFilter: true,
          filterVariant: 'date',
          enableSorting: false,
          Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_creacion'),
        },
        {
          accessorKey: 'fecha_modificacion',
          header: 'Fecha de Modificación',
          size: 200,
          enableColumnFilter: true,
          filterVariant: 'date',
          enableSorting: false,
          Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_modificacion'),
        },
      ],
      []
    );

    const columnaPreagendamientoPreRechazo = useMemo<MRT_ColumnDef<IPreagendamiento>[]>(
      () => [
        {
          accessorKey: 'identificacion',
          header: 'identificacion',
          size: 180,
          Cell: ({ row }) =>
            row.original?.prospecto_data?.identificacion || 'N/A',
        },
        {
          accessorKey: 'cliente_razon_social',
          header: 'Nombre',
          size: 300,
          Cell: ({ row }) => (
            cellLineaRazonSocial(row.original.contrato_data, row.original.prospecto_data.razon_social)
          ),
        },
        {
          ...cellNotFilter,
          accessorKey: 'observacion_llamada',
          header: 'Observación llamada',
          size: 350,
          Cell: ({ row }) => (
            row.original.observaciones != null
              ? row.original.observaciones.observacion_llamada != null
                ? row.original.observaciones.observacion_llamada
                : 'N/A'
              : 'N/A'
          )
        },
        {
          ...cellNotFilter,
          accessorKey: 'estado_preagendamiento',
          header: 'Estado Preagendamiento',
          Cell: ({ row }) => (
            <EstadoComponente
              backgroundColor={row.original.estado_preagendamiento === EstadosPreagendamientoEnumChoice.APROBADO ? 'green' : 'red'}
              texto={row.original?.estado_preagendamiento || 'N/A'}
            />
          ),
        },
        {
          accessorKey: 'motivo_rechazo',
          header: 'Motivo Rechazo',
          size: 200,
          Cell: ({ row }) => (
            emptyCell(row.original.motivo_rechazo_data?.nombre)
          )
        },
        {
          accessorKey: 'observacion_cancelacion',
          header: 'Observación Cancelación',
          size: 200,
          Cell: ({ row }) => (
            emptyCell(row.original.observaciones?.observacion_cancelacion)
          )
        },

        ////* estado_pago ------------------
        {
          filterVariant: 'select',
          filterSelectOptions: ESTADO_PAGO_CHOICE,
          accessorKey: 'estado_pago',
          header: 'estado pago',
          enableColumnFilter: false,
          enableSorting: false,
          Cell: ({ row }) => {
            const isPendingVoucher =
              row.original?.estado_pago === EstadoPagoEnum.VOUCHER_PENDIENTE;
            return (
              <EstadoComponente
                backgroundColor={isPendingVoucher ? 'orange' : 'green'}
                texto={row.original?.estado_pago || 'N/A'}
              />
            );
          },
        },
        {
          ...cellNotFilter,
          accessorKey: 'descripcion_pago',
          header: 'Descripción de pago',
          size: 300,
          enableColumnFilter: false,
          enableSorting: false,
          Cell: ({ row }) => emptyCellOneLevel(row, 'descripcion_pago'),
        },


        // -------------
        {
          ...cellNotFilter,
          accessorKey: 'direccion',
          header: 'direccion',
          size: 300,
          Cell: ({ row }) => row.original?.preventa_data?.direccion || 'N/A',
        },
        {
          ...cellNotFilter,
          accessorKey: 'fecha_hora_instalacion',
          header: 'FECHA Y HORA INSTALACION',
          size: 210,
          enableColumnFilter: true,
          enableSorting: true,
          Cell: ({ row }) =>
            `${row.original.fecha_instalacion} ${row.original.hora_instalacion}`,
        },
        {
          accessorKey: 'coordenadas',
          header: 'COORDENADAS',
          size: 210,

          Cell: ({ row }) => emptyCellOneLevel(row, 'coordenadas'),
        },
        {
          ...cellNotFilter,
          accessorKey: 'celular',
          header: 'CELULAR CLIENTE',
          size: 180,

          Cell: ({ row }) => row.original?.prospecto_data?.celular || 'N/A',
        },
        {
          ...cellNotFilter,
          accessorKey: 'celular_2',
          header: 'CELULAR 2',
          size: 180,

          Cell: ({ row }) => row.original?.preventa_data?.celular_2 || 'N/A',
        },
        {
          ...cellNotFilter,
          accessorKey: 'email',
          header: 'EMAIL',
          size: 180,
          Cell: ({ row }) => row.original?.preventa_data?.email || 'N/A',
        },

        // Persona de referencia ------------------
        {
          ...cellNotFilter,
          accessorKey: 'persona_referencia_nombre',
          header: 'Persona de referencia',
          size: 210,
          Cell: ({ row }) =>
            row.original?.preventa_data?.persona_referencia_nombre || 'N/A',
        },
        {
          ...cellNotFilter,
          accessorKey: 'persona_referencia_celular',
          header: 'Celular de referencia',
          size: 210,
          Cell: ({ row }) =>
            row.original?.preventa_data?.persona_referencia_celular || 'N/A',
        },
        {
          ...cellNotFilter,
          accessorKey: 'persona_referencia_celular_2',
          header: 'Celular de referencia 2',
          size: 210,
          Cell: ({ row }) =>
            row.original?.preventa_data?.persona_referencia_celular_2 || 'N/A',
        },
        {
          ...cellNotFilter,
          accessorKey: 'persona_referencia_parentesco',
          header: 'Parentesco de referencia',
          size: 210,
          Cell: ({ row }) =>
            row.original?.preventa_data?.persona_referencia_parentesco || 'N/A',
        },

        ///* fk ========================================

        // // plan ------------------
        {
          ...cellNotFilter,
          accessorKey: 'tipo_plan',
          header: 'Tipo Plan',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.tipo_plan || 'N/A';
          },
        },
        {
          ...cellNotFilter,
          accessorKey: 'tipo_servicio',
          header: 'Tipo de servicio',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.tipo_servicio || 'N/A';
          },
        },
        {
          ...cellNotFilter,
          accessorKey: 'plan',
          header: 'Plan de internet',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data.tipo_plan || 'N/A';
          },
        },
        {
          ...cellNotFilter,
          accessorKey: 'velocidad_internet',
          header: 'Velocidad de internet',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.velocidad
              ? `${row.original?.plan_data?.velocidad_subida_maxima} ${row.original?.plan_data?.unidad || ''
              }`
              : 'N/A';
          },
        },
        {
          ...cellNotFilter,
          accessorKey: 'valor_plan',
          header: 'Valor del plan',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.valor_plan
              ? formatCurrency(row.original?.preventa_data?.valor_plan)
              : formatCurrency(0);
          },
        },

        // valor_instalacion ------------------
        {
          ...cellNotFilter,

          accessorKey: 'valor_instalacion',
          header: 'Valor Instalación',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.valor_instalacion
              ? formatCurrency(row.original?.preventa_data?.valor_instalacion)
              : formatCurrency(0);
          },
        },
        {
          ...cellNotFilter,
          accessorKey: 'valor_instalacion_iva',
          header: 'Valor IVA Instalación',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.valor_instalacion_iva
              ? formatCurrency(
                row.original?.preventa_data?.valor_instalacion_iva
              )
              : formatCurrency(0);
          },
        },
        {
          ...cellNotFilter,
          accessorKey: 'valor_instalacion_total',
          header: 'Valor Total Instalación',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.valor_instalacion_total
              ? formatCurrency(
                row.original?.preventa_data?.valor_instalacion_total
              )
              : formatCurrency(0);
          },
        },

        // flota & nap ------------------
        {
          accessorKey: 'flota',
          header: 'FLOTA',
          size: 180,
          Cell: ({ row }) => row.original?.flota_data?.nombre || 'N/A',
        },
        {
          accessorKey: 'nap_data_nombre',
          header: 'NAP',
          size: 180,
          Cell: ({ row }) => row.original?.nap_data_nombre || 'N/A',
        },
        {
          accessorKey: 'distancia',
          header: 'DISTANCIA A LA NAP',
          size: 180,
          Cell: ({ row }) => emptyCellOneLevel(row, 'distancia'),
        },

        // encuesta y usos ------------------
        {
          ...cellNotFilter,
          accessorKey: 'encuesta',
          header: 'Encuesta',
          size: 81,
          Cell: ({ row }) => {
            return (
              <EncuestaPreagendaCell encuesta={row.original.encuesta as any} />
            );
          },
        },

        // segmentacion ------------------
        {
          ...cellNotFilter,
          accessorKey: 'segmentacion',
          header: 'SEGMENTACIÓN',
          size: 180,
          Cell: ({ row }) =>
            row.original?.prospecto_data?.segmentacion || 'N/A',
        },
        {
          ...cellNotFilter,
          accessorKey: 'puntaje_score',
          header: 'PUNTAJE SCORE',
          size: 180,
          Cell: ({ row }) =>
            row.original?.prospecto_data?.puntaje_score || 'N/A',
        },

        {
          ...cellNotFilter,
          accessorKey: 'canal_venta_create',
          header: 'Canal Venta',
        },
        {
          ...cellNotFilter,
          accessorKey: 'forma_pago_data.alias',
          header: 'Forma de Pago',
          Cell: ({ row }) => (
            <InfoFormaPago
              preventa_data={row.original.preventa_data!}
              forma_pago_data={row.original.forma_pago_data}
              forma_pago_v2_data={(row.original as any).forma_pago_v2_data} />
          )
        },
        {
          accessorKey: 'user_create',
          header: 'Asesor Venta',
          size: 200,
          Cell: ({ row }) => (
            <InfoUser
              user={row.original.user_create}
            />
          )
        },
        {
          accessorKey: 'fecha_creacion',
          header: 'Fecha de Creación',
          size: 200,
          enableColumnFilter: true,
          filterVariant: 'date',
          enableSorting: false,
          Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_creacion'),
        },
        {
          accessorKey: 'fecha_modificacion',
          header: 'Fecha de Modificación',
          size: 200,
          enableColumnFilter: true,
          filterVariant: 'date',
          enableSorting: false,
          Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_modificacion'),
        },
      ],
      []
    );

    const columnaAgendamiento = useMemo<MRT_ColumnDef<Agendamiento>[]>(
      () => [
        {
          accessorKey: 'identificacion',
          header: 'identificacion',
          size: 180,
          Cell: ({ row }) =>
            row.original?.prospecto_data?.identificacion || 'N/A',
        },
        {
          accessorKey: 'razon_social',
          header: 'Nombre',
          size: 300,
          Cell: ({ row }) =>
            row.original?.prospecto_data?.razon_social || 'N/A',
        },
        {
          accessorKey: 'numero_contrato',
          header: 'Núm. Contrato',
          size: 240,
          Cell: ({ row }) =>
            row.original?.contrato_data?.numero_referencia || 'N/A',
        },
        {
          accessorKey: 'estado_agendamiento',
          header: 'estado agendamiento',
          Cell: ({ }) => (
            <EstadoComponente backgroundColor={'green'} texto={'AGENDADO'} />
          ),
        },

        ////* estado_pago ------------------
        {
          accessorKey: 'estado_pago',
          header: 'estado pago',
          size: 150,
          enableColumnFilter: false,
          enableSorting: false,
          Cell: ({ row }) => {
            const isPendingVoucher =
              row.original?.preagendamiento_data?.estado_pago ===
              EstadoPagoEnum.VOUCHER_PENDIENTE;
            return (
              <EstadoComponente
                backgroundColor={isPendingVoucher ? 'blue' : 'green'}
                texto={row.original?.preagendamiento_data?.estado_pago || 'N/A'}
              />
            );
          },
        },
        {
          accessorKey: 'descripcion_pago',
          header: 'Descripción de pago',
          size: 300,
          enableColumnFilter: false,
          enableSorting: false,
          Cell: ({ row }) => emptyCellOneLevel(row, 'descripcion_pago'),
        },

        // estado llamada ------------------
        {
          accessorKey: 'estado_llamada',
          header: 'Estado de llamada',
          size: 300,
          enableColumnFilter: false,
          enableSorting: false,
          Cell: ({ row }) => {
            return row.original?.estado_llamada ? (
              <EstadoLlamadaComponent estado={row.original.estado_llamada} />
            ) : (
              'N/A'
            );
          },
        },
        {
          accessorKey: 'observacion_llamada',
          header: 'Observación de llamada',
          size: 300,
          enableColumnFilter: false,
          enableSorting: false,
          Cell: ({ row }) => {
            return row.original?.observaciones?.observacion_llamada || 'N/A';
          },
        },
        {
          accessorKey: 'fecha_hora_llamada',
          header: 'FECHA HORA LLAMADA',
          size: 180,
          enableColumnFilter: true,
          enableSorting: true,
          Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_hora_llamada'),
        },

        // -------------
        {
          accessorKey: 'direccion',
          header: 'direccion',
          size: 300,
          Cell: ({ row }) => row.original?.preventa_data?.direccion || 'N/A',
        },
        {
          accessorKey: 'fecha_hora_instalacion',
          header: 'FECHA HORA INSTALACION',
          size: 210,
          enableColumnFilter: true,
          enableSorting: true,
          Cell: ({ row }) =>
            formatDateWithTimeCell(row, 'fecha_hora_instalacion'),
        },
        {
          accessorKey: 'coordenadas',
          header: 'COORDENADAS',
          size: 210,

          Cell: ({ row }) => emptyCellOneLevel(row, 'coordenadas'),
        },
        {
          accessorKey: 'celular',
          header: 'CELULAR CLIENTE',
          size: 180,

          Cell: ({ row }) => row.original?.prospecto_data?.celular || 'N/A',
        },
        {
          accessorKey: 'celular_2',
          header: 'CELULAR 2',
          size: 180,

          Cell: ({ row }) => row.original?.preventa_data?.celular_2 || 'N/A',
        },
        {
          accessorKey: 'email',
          header: 'EMAIL',
          size: 180,
          Cell: ({ row }) => row.original?.preventa_data?.email || 'N/A',
        },

        // Persona de referencia ------------------
        {
          accessorKey: 'persona_referencia_nombre',
          header: 'Persona de referencia',
          size: 210,
          Cell: ({ row }) =>
            row.original?.preventa_data?.persona_referencia_nombre || 'N/A',
        },
        {
          accessorKey: 'persona_referencia_celular',
          header: 'Celular de referencia',
          size: 210,
          Cell: ({ row }) =>
            row.original?.preventa_data?.persona_referencia_celular || 'N/A',
        },
        {
          accessorKey: 'persona_referencia_celular_2',
          header: 'Celular de referencia 2',
          size: 210,
          Cell: ({ row }) =>
            row.original?.preventa_data?.persona_referencia_celular_2 || 'N/A',
        },
        {
          accessorKey: 'persona_referencia_parentesco',
          header: 'Parentesco de referencia',
          size: 210,
          Cell: ({ row }) =>
            row.original?.preventa_data?.persona_referencia_parentesco || 'N/A',
        },

        ///* fk ========================================

        // // plan ------------------
        {
          accessorKey: 'tipo_plan',
          header: 'Tipo Plan',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.tipo_plan || 'N/A';
          },
        },
        {
          accessorKey: 'tipo_servicio',
          header: 'Tipo de servicio',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.tipo_servicio || 'N/A';
          },
        },
        {
          accessorKey: 'plan',
          header: 'Plan de internet',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.plan_data?.nombre || 'N/A';
          },
        },
        {
          accessorKey: 'velocidad_internet',
          header: 'Velocidad de internet',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.velocidad
              ? `${row.original?.preventa_data?.velocidad} ${row.original?.preventa_data?.plan_data?.unidad}`
              : 'N/A';
          },
        },
        {
          accessorKey: 'valor_plan',
          header: 'Valor del plan',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.valor_plan
              ? formatCurrency(row.original?.preventa_data?.valor_plan)
              : formatCurrency(0);
          },
        },

        // valor_instalacion ------------------
        {
          accessorKey: 'valor_instalacion',
          header: 'Valor Instalación',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.valor_instalacion
              ? formatCurrency(row.original?.preventa_data?.valor_instalacion)
              : formatCurrency(0);
          },
        },
        {
          accessorKey: 'valor_instalacion_iva',
          header: 'Valor IVA Instalación',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.valor_instalacion_iva
              ? formatCurrency(
                row.original?.preventa_data?.valor_instalacion_iva
              )
              : formatCurrency(0);
          },
        },
        {
          accessorKey: 'valor_instalacion_total',
          header: 'Valor Total Instalación',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.valor_instalacion_total
              ? formatCurrency(
                row.original?.preventa_data?.valor_instalacion_total
              )
              : formatCurrency(0);
          },
        },

        // flota & nap ------------------
        {
          accessorKey: 'flota',
          header: 'FLOTA',
          size: 180,
          Cell: ({ row }) => row.original?.flota_data?.nombre || 'N/A',
        },
        {
          accessorKey: 'nap_data_nombre',
          header: 'NAP',
          size: 180,
          Cell: ({ row }) => row.original?.nap_data_nombre || 'N/A',
        },
        {
          accessorKey: 'distancia',
          header: 'DISTANCIA A LA NAP',
          size: 180,
          Cell: ({ row }) => emptyCellOneLevel(row, 'distancia'),
        },

        {
          accessorKey: 'contrato',
          header: 'CONTRATO',
          size: 180,
          Cell: ({ row }) => {
            const url = row.original?.contrato_data?.url_contrato;
            if (!url) return 'N/A';

            return (
              <SingleIconButton
                startIcon={<PictureAsPdfIcon />}
                label="Ver contrato"
                color="error"
                onClick={() => {
                  window.open(url, '_blank');
                }}
              />
            );
          },
        },

        // segmentacion ------------------
        {
          accessorKey: 'segmentacion',
          header: 'SEGMENTACIÓN',
          size: 180,
          Cell: ({ row }) =>
            row.original?.prospecto_data?.segmentacion || 'N/A',
        },
        {
          accessorKey: 'puntaje_score',
          header: 'PUNTAJE SCORE',
          size: 180,
          Cell: ({ row }) =>
            row.original?.prospecto_data?.puntaje_score || 'N/A',
        },

        // //////////////////////////////////////////////

        {
          accessorKey: 'url_foto_identificacion_delantera',
          header: 'URL FOTO IDENTIFICACION DELANTERA',
          size: 180,
          enableColumnFilter: true,
          enableSorting: true,
          Cell: ({ row }) =>
            emptyCellOneLevel(row, 'url_foto_identificacion_delantera'),
        },
        {
          accessorKey: 'url_foto_identificacion_posterior',
          header: 'URL FOTO IDENTIFICACION POSTERIOR',
          size: 180,
          enableColumnFilter: true,
          enableSorting: true,
          Cell: ({ row }) =>
            emptyCellOneLevel(row, 'url_foto_identificacion_posterior'),
        },
        {
          accessorKey: 'url_foto_aceptacion',
          header: 'URL FOTO ACEPTACION',
          size: 180,
          enableColumnFilter: true,
          enableSorting: true,
          Cell: ({ row }) => emptyCellOneLevel(row, 'url_foto_aceptacion'),
        },
      ],
      []
    );

    const columnaComprobantePago = useMemo<MRT_ColumnDef<IPreagendamiento>[]>(
      () => [
        {
          accessorKey: 'identificacion',
          header: 'identificacion',
          size: 180,
          Cell: ({ row }) =>
            row.original?.prospecto_data?.identificacion || 'N/A',
        },
        {
          accessorKey: 'razon_social',
          header: 'Nombre',
          size: 300,
          Cell: ({ row }) =>
            row.original?.prospecto_data?.razon_social || 'N/A',
        },
        {
          accessorKey: 'numero_contrato',
          header: 'Núm. Contrato',
          size: 240,
          Cell: ({ row }) =>
            row.original?.contrato_data?.numero_referencia || 'N/A',
        },
        ////* estado_pago ------------------
        {
          accessorKey: 'valor_instalacion',
          header: 'valor Instalación Pendiente',
          size: 100,
          Cell: ({ row }) =>
            row.original.preventa_data.valor_instalacion_total != null ? (
              <EstadoComponente
                backgroundColor={'orange'}
                texto={
                  `$ ${row.original.preventa_data.valor_instalacion_total}` ||
                  ''
                }
              />
            ) : null,
        },
        {
          accessorKey: 'estado_pago',
          header: 'estado pago',
          size: 150,
          enableColumnFilter: false,
          enableSorting: false,
          Cell: ({ row }) => {
            const isPendingVoucher =
              row.original?.estado_pago === EstadoPagoEnum.VOUCHER_PENDIENTE;
            return (
              <EstadoComponente
                backgroundColor={isPendingVoucher ? 'blue' : 'green'}
                texto={row.original?.estado_pago || 'N/A'}
              />
            );
          },
        },
        {
          accessorKey: 'descripcion_pago',
          header: 'Descripción de pago',
          size: 300,
          enableColumnFilter: false,
          enableSorting: false,
          Cell: ({ row }) => emptyCellOneLevel(row, 'descripcion_pago'),
        },

        {
          accessorKey: 'celular',
          header: 'CELULAR CLIENTE',
          size: 180,

          Cell: ({ row }) => row.original?.prospecto_data?.celular || 'N/A',
        },
        {
          accessorKey: 'celular_2',
          header: 'CELULAR 2',
          size: 180,

          Cell: ({ row }) => row.original?.preventa_data?.celular_2 || 'N/A',
        },
        {
          accessorKey: 'email',
          header: 'EMAIL',
          size: 180,
          Cell: ({ row }) => row.original?.preventa_data?.email || 'N/A',
        },

        {
          accessorKey: 'contrato',
          header: 'CONTRATO',
          size: 180,
          Cell: ({ row }) => {
            const url = row.original?.contrato_data?.url_contrato;
            if (!url) return 'N/A';

            return (
              <SingleIconButton
                startIcon={<PictureAsPdfIcon />}
                label="Ver contrato"
                color="error"
                onClick={() => {
                  window.open(url, '_blank');
                }}
              />
            );
          },
        },

        // segmentacion ------------------
        {
          accessorKey: 'segmentacion',
          header: 'SEGMENTACIÓN',
          size: 180,
          Cell: ({ row }) =>
            row.original?.prospecto_data?.segmentacion || 'N/A',
        },
        {
          accessorKey: 'puntaje_score',
          header: 'PUNTAJE SCORE',
          size: 180,
          Cell: ({ row }) =>
            row.original?.prospecto_data?.puntaje_score || 'N/A',
        },

        {
          accessorKey: 'user_create',
          header: 'Asesor Venta',
          size: 200,
          Cell: ({ row }) => row.original.user_create
        }
      ],
      []
    );

    const columnaPreagendamientoActualizar = useMemo<
      MRT_ColumnDef<IPreagendamiento>[]
    >(
      () => [
        {
          accessorKey: 'identificacion',
          header: 'identificacion',
          size: 180,
          Cell: ({ row }) =>
            row.original?.prospecto_data?.identificacion || 'N/A',
        },
        {
          accessorKey: 'razon_social',
          header: 'Nombre',
          size: 300,
          Cell: ({ row }) =>
            row.original?.prospecto_data?.razon_social || 'N/A',
        },
        {
          accessorKey: 'motivo_rechazo',
          header: 'motivo de Rechazo',
          Cell: ({ row }) => (
            row.original.motivo_rechazo_data != null ?
              row.original.motivo_rechazo_data.nombre : 'N/A'
          )
        },

        {
          accessorKey: 'Estado',
          header: 'estado preagendamiento',
          size: 150,
          Cell: ({ row }) => (
            <EstadoComponente backgroundColor={'red'} texto={row.original.estado_preagendamiento} />
          ),
        },

        // -------------
        {
          accessorKey: 'direccion',
          header: 'direccion',
          size: 300,
          Cell: ({ row }) => row.original?.preventa_data?.direccion || 'N/A',
        },
        {
          accessorKey: 'fecha_hora_instalacion',
          header: 'FECHA HORA INSTALACION',
          size: 210,
          enableColumnFilter: true,
          enableSorting: true,
          Cell: ({ row }) =>
            formatDateWithTimeCell(row, 'fecha_hora_instalacion'),
        },
        {
          accessorKey: 'coordenadas',
          header: 'COORDENADAS',
          size: 210,

          Cell: ({ row }) => emptyCellOneLevel(row, 'coordenadas'),
        },
        {
          accessorKey: 'celular',
          header: 'CELULAR CLIENTE',
          size: 180,

          Cell: ({ row }) => row.original?.prospecto_data?.celular || 'N/A',
        },
        {
          accessorKey: 'celular_2',
          header: 'CELULAR 2',
          size: 180,

          Cell: ({ row }) => row.original?.preventa_data?.celular_2 || 'N/A',
        },
        {
          accessorKey: 'email',
          header: 'EMAIL',
          size: 180,
          Cell: ({ row }) => row.original?.preventa_data?.email || 'N/A',
        },

        // Persona de referencia ------------------
        {
          accessorKey: 'persona_referencia_nombre',
          header: 'Persona de referencia',
          size: 210,
          Cell: ({ row }) =>
            row.original?.preventa_data?.persona_referencia_nombre || 'N/A',
        },
        {
          accessorKey: 'persona_referencia_celular',
          header: 'Celular de referencia',
          size: 210,
          Cell: ({ row }) =>
            row.original?.preventa_data?.persona_referencia_celular || 'N/A',
        },
        {
          accessorKey: 'persona_referencia_celular_2',
          header: 'Celular de referencia 2',
          size: 210,
          Cell: ({ row }) =>
            row.original?.preventa_data?.persona_referencia_celular_2 || 'N/A',
        },
        {
          accessorKey: 'persona_referencia_parentesco',
          header: 'Parentesco de referencia',
          size: 210,
          Cell: ({ row }) =>
            row.original?.preventa_data?.persona_referencia_parentesco || 'N/A',
        },

        ///* fk ========================================

        // // plan ------------------
        {
          accessorKey: 'tipo_plan',
          header: 'Tipo Plan',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.tipo_plan || 'N/A';
          },
        },
        {
          accessorKey: 'tipo_servicio',
          header: 'Tipo de servicio',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.tipo_servicio || 'N/A';
          },
        },
        {
          accessorKey: 'plan',
          header: 'Plan de internet',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data.tipo_plan || 'N/A';
          },
        },
        {
          accessorKey: 'velocidad_internet',
          header: 'Velocidad de internet',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.velocidad
              ? `${row.original?.preventa_data?.velocidad} ${row.original?.preventa_data?.plan_data?.unidad}`
              : 'N/A';
          },
        },
        {
          accessorKey: 'valor_plan',
          header: 'Valor del plan',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.valor_plan
              ? formatCurrency(row.original?.preventa_data?.valor_plan)
              : formatCurrency(0);
          },
        },

        // valor_instalacion ------------------
        {
          accessorKey: 'valor_instalacion',
          header: 'Valor Instalación',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.valor_instalacion
              ? formatCurrency(row.original?.preventa_data?.valor_instalacion)
              : formatCurrency(0);
          },
        },
        {
          accessorKey: 'valor_instalacion_iva',
          header: 'Valor IVA Instalación',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.valor_instalacion_iva
              ? formatCurrency(
                row.original?.preventa_data?.valor_instalacion_iva
              )
              : formatCurrency(0);
          },
        },
        {
          accessorKey: 'valor_instalacion_total',
          header: 'Valor Total Instalación',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.valor_instalacion_total
              ? formatCurrency(
                row.original?.preventa_data?.valor_instalacion_total
              )
              : formatCurrency(0);
          },
        },

        // flota & nap ------------------
        {
          accessorKey: 'flota',
          header: 'FLOTA',
          size: 180,
          Cell: ({ row }) => row.original?.flota_data?.nombre || 'N/A',
        },
        {
          accessorKey: 'nap_data_nombre',
          header: 'NAP',
          size: 180,
          Cell: ({ row }) => row.original?.nap_data_nombre || 'N/A',
        },
        {
          accessorKey: 'distancia',
          header: 'DISTANCIA A LA NAP',
          size: 180,
          Cell: ({ row }) => emptyCellOneLevel(row, 'distancia'),
        },

        {
          accessorKey: 'contrato',
          header: 'CONTRATO',
          size: 180,
          Cell: ({ row }) => {
            const url = row.original?.contrato_data?.url_contrato;
            if (!url) return 'N/A';

            return (
              <SingleIconButton
                startIcon={<PictureAsPdfIcon />}
                label="Ver contrato"
                color="error"
                onClick={() => {
                  window.open(url, '_blank');
                }}
              />
            );
          },
        },

        // encuesta y usos ------------------
        {
          accessorKey: 'encuesta',
          header: 'Encuesta',
          size: 81,
          Cell: ({ row }) => {
            return (
              <EncuestaPreagendaCell encuesta={row.original.encuesta as any} />
            );
          },
        },

        // segmentacion ------------------
        {
          accessorKey: 'segmentacion',
          header: 'SEGMENTACIÓN',
          size: 180,
          Cell: ({ row }) =>
            row.original?.prospecto_data?.segmentacion || 'N/A',
        },
        {
          accessorKey: 'puntaje_score',
          header: 'PUNTAJE SCORE',
          size: 180,
          Cell: ({ row }) =>
            row.original?.prospecto_data?.puntaje_score || 'N/A',
        },

        // //////////////////////////////////////////////

        {
          accessorKey: 'url_foto_identificacion_delantera',
          header: 'URL FOTO IDENTIFICACION DELANTERA',
          size: 180,
          enableColumnFilter: true,
          enableSorting: true,
          Cell: ({ row }) =>
            emptyCellOneLevel(row, 'url_foto_identificacion_delantera'),
        },
        {
          accessorKey: 'url_foto_identificacion_posterior',
          header: 'URL FOTO IDENTIFICACION POSTERIOR',
          size: 180,
          enableColumnFilter: true,
          enableSorting: true,
          Cell: ({ row }) =>
            emptyCellOneLevel(row, 'url_foto_identificacion_posterior'),
        },
        {
          accessorKey: 'user_create',
          header: 'Asesor Venta',
          size: 200,
          Cell: ({ row }) => (
            <InfoUser user={row.original.user_create} />
          )
        },
        {
          accessorKey: 'canal_venta_create',
          header: 'canal venta',
          size: 200,
        }
      ],
      []
    );


    ///* Columna para ver contratos de preagendamiento
    const columnaOrdebTrabajoContrato = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
      () => [
        {
          accessorKey: 'identificacion',
          header: 'identificacion',
          size: 180,
          Cell: ({ row }) =>
            row.original?.prospecto_data?.identificacion || 'N/A',
        },
        {
          ...cellNotFilter,
          accessorKey: 'razon_social',
          header: 'Nombre',
          size: 300,
          Cell: ({ row }) => (
            cellLineaRazonSocial(row.original.contrato_data, row.original.prospecto_data?.razon_social!)
          ),
        },
        {
          accessorKey: 'numero_contrato',
          header: 'Núm. Contrato',
          Cell: ({ row }) =>
            row.original?.contrato_data?.numero_referencia || 'N/A',
        },

        {
          ...cellNotFilter,
          accessorKey: 'requiere_contrato_fisico',
          header: 'Tipo de Contrato',
          size: 250,
          Cell: ({ row }) => (
            <EstadoComponente
              backgroundColor={fnTipoContrato(
                row.original.preventa_data?.pre_requiere_contrato_fisico, row.original.preventa_data?.requiere_contrato_fisico).color}
              texto={fnTipoContrato(
                row.original.preventa_data?.pre_requiere_contrato_fisico, row.original.preventa_data?.requiere_contrato_fisico).texto} />
          ),
        },

        {
          ...cellNotFilter,
          accessorKey: 'contrato_data',
          header: 'Documentos',
          Cell: ({ row }) => (
            <ShowContractsAgendaModal

              razonSocial={cellLineaRazonSocial(row.original.contrato_data, row.original.prospecto_data?.razon_social!)}
              contrato={row.original.contrato_data!}
              tooltipMessage={"Documentos generados"}
              idPreventa={row.original.preventa_data?.id_preventa}
              ordenTrabajoId={row.original.id_orden_trabajo}
              //solo para pyl
              showBtnForward={true}
              showBtnGenDocs={true}
              showBtnCopy={false}
            />
          )
        },
        {
          ...cellNotFilter,
          accessorKey: 'preventa_data',
          header: 'Imagenes',
          Cell: ({ row }) => (
            row.original.preventa_data != null ?
              <ModalFotoContratoComponente
                preventa_data={row.original.preventa_data!}
              /> :
              'N/A'
          )
        },
        {
          ...cellNotFilter,
          accessorKey: 'forma_pago_data.alias',
          header: 'Forma de Pago',
          Cell: ({ row }) => (
            <InfoFormaPago
              preventa_data={row.original.preventa_data!}
              forma_pago_data={row.original.forma_pago_data!}
              forma_pago_v2_data={(row.original as any).forma_pago_v2_data} />
          )
        },
        {
          ...cellNotFilter,
          accessorKey: 'estado_aceptacion',
          header: 'Estado Aceptacion',
          size: 200,
          Cell: ({ row }) => (
            <EstadoComponente backgroundColor={row.original.preventa_data?.estado_aceptacion ? 'green' : 'orange'} texto={row.original.preventa_data?.estado_aceptacion ? 'FIRMADO' : 'PENDIENTE FIRMAR'} />
          )
        },

        ////* estado_pago ------------------
        {
          ...cellNotFilter,
          accessorKey: 'estado_pago',
          header: 'estado pago',
          enableColumnFilter: false,
          enableSorting: false,
          Cell: ({ row }) => {
            const isPendingVoucher =
              row.original.preagendamiento_data?.estado_pago === EstadoPagoEnum.VOUCHER_PENDIENTE;
            return (
              <EstadoComponente
                backgroundColor={isPendingVoucher ? 'orange' : 'green'}
                texto={row.original.preagendamiento_data?.estado_pago || 'N/A'}
              />
            );
          },
        },
        {
          accessorKey: 'descripcion_pago',
          header: 'Descripción de pago',
          size: 300,
          enableColumnFilter: false,
          enableSorting: false,
          Cell: ({ row }) => emptyCellOneLevel(row, 'descripcion_pago'),
        },


        // -------------
        {
          accessorKey: 'direccion',
          header: 'direccion',
          size: 300,
          Cell: ({ row }) => row.original?.preventa_data?.direccion || 'N/A',
        },
        {
          accessorKey: 'fecha_hora_instalacion',
          header: 'FECHA Y HORA INSTALACION',
          size: 210,
          enableColumnFilter: true,
          enableSorting: true,
          Cell: ({ row }) =>
            `${row.original.fecha_instalacion} ${row.original.hora_instalacion}`,
        },

        {
          accessorKey: 'celular',
          header: 'CELULAR CLIENTE',
          size: 180,

          Cell: ({ row }) => row.original?.prospecto_data?.celular || 'N/A',
        },
        {
          accessorKey: 'celular_2',
          header: 'CELULAR 2',
          size: 180,

          Cell: ({ row }) => row.original?.preventa_data?.celular_2 || 'N/A',
        },
        {
          accessorKey: 'email',
          header: 'EMAIL',
          size: 180,
          Cell: ({ row }) => row.original?.preventa_data?.email || 'N/A',
        },

        // // plan ------------------
        {
          accessorKey: 'tipo_plan',
          header: 'Tipo Plan',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.tipo_plan || 'N/A';
          },
        },
        {
          accessorKey: 'tipo_servicio',
          header: 'Tipo de servicio',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.tipo_servicio || 'N/A';
          },
        },
        {
          accessorKey: 'plan',
          header: 'Plan de internet',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.tipo_plan || 'N/A';
          },
        },
        {
          accessorKey: 'velocidad_internet',
          header: 'Velocidad de internet',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.velocidad
              ? `${row.original?.plan_data?.velocidad_subida_maxima} ${row.original?.plan_data?.unidad || ''
              }`
              : 'N/A';
          },
        },
        {
          accessorKey: 'valor_plan',
          header: 'Valor del plan',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.valor_plan
              ? formatCurrency(row.original?.preventa_data?.valor_plan)
              : formatCurrency(0);
          },
        },

        // valor_instalacion ------------------
        {
          accessorKey: 'valor_instalacion',
          header: 'Valor Instalación',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.valor_instalacion
              ? formatCurrency(row.original?.preventa_data?.valor_instalacion)
              : formatCurrency(0);
          },
        },
        {
          accessorKey: 'valor_instalacion_iva',
          header: 'Valor IVA Instalación',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.valor_instalacion_iva
              ? formatCurrency(
                row.original?.preventa_data?.valor_instalacion_iva
              )
              : formatCurrency(0);
          },
        },
        {
          accessorKey: 'valor_instalacion_total',
          header: 'Valor Total Instalación',
          size: 210,
          Cell: ({ row }) => {
            return row.original?.preventa_data?.valor_instalacion_total
              ? formatCurrency(
                row.original?.preventa_data?.valor_instalacion_total
              )
              : formatCurrency(0);
          },
        },

        // flota & nap ------------------
        {
          accessorKey: 'flota',
          header: 'FLOTA',
          size: 180,
          Cell: ({ row }) => row.original?.flota_data?.nombre || 'N/A',
        },
        {
          accessorKey: 'nap_data_nombre',
          header: 'NAP',
          size: 180,
          Cell: ({ row }) => row.original?.nap_data_nombre || 'N/A',
        },
        {
          accessorKey: 'distancia',
          header: 'DISTANCIA A LA NAP',
          size: 180,
          Cell: ({ row }) => emptyCellOneLevel(row, 'distancia'),
        },

        // encuesta y usos ------------------
        {
          accessorKey: 'encuesta',
          header: 'Encuesta',
          size: 81,
          Cell: ({ row }) => {
            return (
              <EncuestaPreagendaCell encuesta={row.original.preagendamiento_data?.encuesta as any} />
            );
          },
        },

        // segmentacion ------------------
        {
          accessorKey: 'segmentacion',
          header: 'SEGMENTACIÓN',
          size: 180,
          Cell: ({ row }) =>
            row.original?.prospecto_data?.segmentacion || 'N/A',
        },
        {
          accessorKey: 'puntaje_score',
          header: 'PUNTAJE SCORE',
          size: 180,
          Cell: ({ row }) =>
            row.original?.prospecto_data?.puntaje_score || 'N/A',
        },

        {
          accessorKey: 'canal_venta_create',
          header: 'Canal Venta',
        },

        {
          accessorKey: 'user_create',
          header: 'Asesor Venta',
          size: 200,
          Cell: ({ row }) => (
            <InfoUser
              user={row.original.user_create}
            />
          )
        }
      ],
      []
    );


    return {
      columnaPreagendamientoActualizar,
      columnaComprobantePago,
      columnaPreagendamiento,
      columnaAgendamiento,
      columnaPreagendamientoPreRechazo,
      columnaOrdebTrabajoContrato
    };
  };
